import { StagingPageOutletContext } from "../../StagingPage";
import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import RecorderEditInner from "pages/recorders/edit/list";

export default function StagingEditContainer() {
  const { setButtons, setClassName, setNoSearch, setCenterChildren } =
    useOutletContext<StagingPageOutletContext>();
  useEffect(() => {
    setButtons(null);
    setClassName("bg-container");
    setNoSearch(true);
    setCenterChildren(null);
  }, [setButtons]);
  return <RecorderEditInner />;
}
